import Cookies from 'js-cookie';

/* @type {string} */
const cookieName = 'mn_instore_info';

/**
 * Update the value of the Instore Info cookie
 */
export const setInstoreInfoCookie = (cookieDomain, isHttps) => {
  let cookieValue = null;

  if (window.instoreData) {
    const { cardholderId, isLinkingOnBoardingComplete, isAddCardOnBoardingComplete } = window.instoreData;
    const instoreInfoCookieValue = {
      cardholderId,
      isLinkingOnBoardingComplete,
      isAddCardOnBoardingComplete,
    };
    cookieValue = JSON.stringify(instoreInfoCookieValue);

    Cookies.set(cookieName, cookieValue, {
      path: '/',
      domain: cookieDomain,
      secure: isHttps,
    });
  }

  return cookieValue;
};
